// extracted by mini-css-extract-plugin
module.exports = {"header":"_2QXuF","title":"_3ynZD","closeBtn":"_2JDiv","content":"_12iB5","image":"_28q8G"};